import { GetIsCategoryPickerVisible } from './types/getIsCategoryPickerVisible.types'

export const getIsCategoryPickerVisible: GetIsCategoryPickerVisible = (
  category,
  packageConf
) => (
  packageConf[category].visible
)
